import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_TEAM_SETUP_CHANNEL_NAME', function setTeamSetupChannelName(channelName: string) {
    if (teamSetupPickerStore.teamSetupInfo) {
        teamSetupPickerStore.teamSetupInfo.channelName = channelName;
    }
});
